// src/pages/Home/Home.jsx
import React, { useState } from "react";
import Layout from "../../components/Layout/Layout";
import AnnouncementBanner from "../../components/AnnouncementBanner/AnnouncementBanner";
import "./Home.css";

const Home = () => {
  const [testimonialIndex, setTestimonialIndex] = useState(0);

  const testimonials = [
    { name: "Student 1", text: "MyEduGenius made studying fun and easy!" },
    { name: "Teacher 1", text: "I save hours every week preparing lessons." },
    { name: "Student 2", text: "The quizzes helped me pass my exams." },
  ];

  const agents = [
    {
      name: "Tutor Agent",
      desc: "Explains topics and answers questions instantly",
      icon: "📘",
    },
    {
      name: "Quiz Agent",
      desc: "Generates smart practice quizzes with feedback",
      icon: "📝",
    },
    {
      name: "Teacher Support Agent",
      desc: "Helps teachers create lesson aids and summaries",
      icon: "👩‍🏫",
    },
    {
      name: "Progress Agent",
      desc: "Tracks student performance and progress",
      icon: "📊",
    },
    {
      name: "Summarizing Agent",
      desc: "Condenses materials into key points for faster learning",
      icon: "📄",
    },
    {
      name: "Recommendation Agent",
      desc: "Suggests personalized learning paths and resources",
      icon: "💡",
    },
    {
      name: "Analytics Agent",
      desc: "Provides insights into learning patterns and performance",
      icon: "📈",
    },
    {
      name: "Feedback Agent",
      desc: "Gives constructive feedback on assignments and improvements",
      icon: "💬",
    },
  ];

  const stats = [
    { label: "Students", value: "1,200+" },
    { label: "Lessons", value: "350+" },
    { label: "Quizzes Solved", value: "5,400+" },
    { label: "Teachers Supported", value: "75+" },
  ];

  const nextTestimonial = () =>
    setTestimonialIndex((prev) => (prev + 1) % testimonials.length);
  const prevTestimonial = () =>
    setTestimonialIndex(
      (prev) => (prev - 1 + testimonials.length) % testimonials.length
    );

  return (
    <Layout>
      <AnnouncementBanner />
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-text">
          <h1>Welcome to Your Learning Journey!</h1>
          <p>
            Access your personalized dashboard, track your progress, and get
            help from AI-powered agents.
          </p>
          <div className="hero-buttons">
            <a href="/dashboard" className="btn">
              Go to Dashboard
            </a>
          </div>
        </div>

        <div className="tutor-preview">
          <div className="tutor-card">
            <div className="tutor-header">
              <div className="tutor-icon">📘</div>
              <div>
                <h3>Tutor Agent</h3>
                <p>AI Assistant</p>
              </div>
            </div>
            <p className="tutor-text">
              "Hi! I can help explain complex concepts in simple terms. What
              would you like to learn today?"
            </p>
            <div className="tutor-input">
              <p>Ask me anything about math, science, or literature...</p>
            </div>
          </div>
        </div>
      </section>

      {/* Agent Cards */}
      <section className="agents-section">
        {agents.map((agent, idx) => (
          <div key={idx} className="agent-card">
            <div className="agent-icon">{agent.icon}</div>
            <h3>{agent.name}</h3>
            <p>{agent.desc}</p>
          </div>
        ))}
      </section>

      {/* Stats / Infographic */}
      <section className="stats-section">
        {stats.map((stat, idx) => (
          <div key={idx} className="stat-card">
            <h2>{stat.value}</h2>
            <p>{stat.label}</p>
          </div>
        ))}
      </section>

      {/* Testimonials */}
      <section className="testimonials-section">
        <button onClick={prevTestimonial} className="testimonial-btn">
          ◀
        </button>
        <div className="testimonial-card">
          <p>"{testimonials[testimonialIndex].text}"</p>
          <h4>- {testimonials[testimonialIndex].name}</h4>
        </div>
        <button onClick={nextTestimonial} className="testimonial-btn">
          ▶
        </button>
      </section>

      {/* Call-to-Action Section */}
      <section className="cta-section">
        <h2>Start your AI-powered learning journey today!</h2>
        <div className="cta-buttons">
          <a href="/register" className="btn">
            Get Started Free
          </a>
        </div>
      </section>
    </Layout>
  );
};

export default Home;
